export default (el) => {

  const $captionWrapper = $(el),
        $btn = $captionWrapper.find('button'),
        $caption = $btn.next()
  ;

  $btn.on('click', () => {
    $btn.attr('aria-expanded', $btn.attr('aria-expanded') === 'true' ? 'false' : 'true');
    $caption.attr('aria-hidden', $caption.attr('aria-hidden') === 'true' ? 'false' : 'true');
  });

  $(document).on('click', ({ target }) => {
    if (!$(target).closest($captionWrapper).length) {
      $btn.attr('aria-expanded', 'false');
      $caption.attr('aria-hidden', 'true');
    }
  });

};
